export default __webpack_public_path__ + "static/layout-do-light-f781309f1796c72ca9473ee7b369d4a85983a417232e1856a0ca8451a61eb610.png";